import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useFreeTrialConfig = () => {
  const { data: freeTrialConfig } = useFetch(
    'api/policies/free-trial-config/',
    {
      hostType: HOST_TYPE.CMS
    }
  );
  return JSON.parse(freeTrialConfig?.description ?? '{}');
};

export default useFreeTrialConfig;
